import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import moment from 'moment';
import {request, NoticeType, PublicType, NoticeClassfiyList, TypesSlect} from 'utils.js'
import brand1 from "static/plantImg/brand1.png";
import brand2 from "static/plantImg/brand2.png";
import brand3 from "static/plantImg/brand3.png";
import brand4 from "static/plantImg/brand4.png";
import brand5 from "static/plantImg/brand5.png";
import class1 from "static/plantImg/class1.jpg";
import class2 from "static/plantImg/class2.jpg";
import class3 from "static/plantImg/class3.jpg";
import BookCheck from 'components/BookCheck';
import newimg from "static/img/new.gif";

import "./index.less";

const NoticeItem = (props) => {
	const { id, noticeName, time, noticeType,projectCode,listDataType } = props;
	const getNoticeIco = () => {
		let icon = '';
		switch (listDataType) {
			case 'publicType':
				icon = PublicType[noticeType];
				break;
			case 'purchaseIntentionNotice':
				icon = '采购意向公示';
				break;
			default:
				icon = NoticeType[noticeType - 1];
				break;
		}
		return icon;
	}
	
	const  getNoticeLink = () => {
		if (listDataType === 'publicType') {
			return  `/inquiryDetail/${id}`;
		} else if(listDataType === 'contractPublicity'){
			return `/contract-detail/${id}`;
		} else if (listDataType === 'bigProject') {
			return `/bigProjectDetail/${id}`;
		} else if(listDataType === 'purchaseIntentionNotice'){
			return `/purchase-intention-detail/${id}`;
		}
		return `/notice-detail/${id}`;
	}
	let newimgShow = moment(new Date(time)).format("YYYY-MM-DD") == moment(new Date()).format("YYYY-MM-DD")
	
	return (
		<div className="notice-item">
      <Link to={getNoticeLink()}>
		<div className="notice-item-title">
			
			{projectCode !== '' && projectCode!==undefined && <span style={{marginLeft: '-8px', color: '#666', paddingRight: '10px'}}>【{projectCode}】</span>}
			{noticeName}{newimgShow?<img src={newimg} /> :''}
		</div>
        <div className="notice-item-subtitle">
		  	 <span>{getNoticeIco(noticeType)}</span>
			 {/* <span className="addresTips"></span> */}
          <span>发布时间：{moment(new Date(time)).format("YYYY-MM-DD")}</span>
        </div>
      </Link>
		</div>
	);
};

const Condition = (props) => {
	const {item,index, selected = false, dataId} = props;
	return (
		<div className={selected ? 'selected': ''} index={index} data-id={dataId}>{item}</div>
	);
};

const NavItem = (props) => {
	let { text, index, onMouseEnter } = props;
	return (
		<a index={index}  onClick={onMouseEnter} >
			{text}
		</a>
	);
};

export default function Notice(props) {
	let { searchText,user } = props;
	const [noticeList, setNoticeList] = useState([])
	const [noticeClassfiy, setNoticeClassfiy] = useState('');
	const [select, setSelect] = useState(TypesSlect[0])
	const onSelected = (e) => {
		const dataId = e.target.getAttribute("data-id");
		const dataRow = TypesSlect.filter(item => item.id == dataId);
		if(!dataRow || dataRow.length == 0) {
			return;
		}
		setSelect(dataRow[0])
	}
	const noticeListApi = () => {
		request({
			method: 'post',
			url: '/aiprt-common-notice-be/notice/data/list',
			data: {
				"page":1,
				"num":10,
				// "noticeType": select,
				'noticeTypes':select.classfiy,
				"noticeClassfiy":noticeClassfiy.classfiy,
				'searchContent': searchText,
			}
		}).then(res => {
			setNoticeList(res.list)
		})
	}
	const inquiryListApi = (pt) => {
		request({
			method: 'post',
			url: '/aiprt-common-notice-be/inquiry/lists',
			data: {
				"page":1,
				"num":10,
				'publicType': pt | select.classfiy,
			}
		}).then(res => {
			const list = res.list.map(item => {
				return {
					id: item.id,
					projectCode: item.code,
					noticeName: item.title,
					releaseTime: item.pushTime,
					noticeType: item.publicType,
					listDataType: 'publicType'
				}
			})
			setNoticeList(list)
		})
	}

	const requestContractListApi = () => {
		request({
			method: 'post',
			url: '/aiprt-common-notice-be/contractPublicity/lists',
			data: {
				"page":1,
				"num":10,
				'signingType': select.pt,
			}
		}).then(res => {
			const list = res.list.map(item => {
				return {
					id: item.id,
					projectCode: item.projectCode,
					noticeName: item.contractPublicityTitle,
					releaseTime: item.releaseTime,
					noticeType: "11",
					listDataType: 'contractPublicity'
				}
			})
			setNoticeList(list)
		})
	}

	const requestBigProjectListApi = () => {
		request({
			method: 'post',
			url: '/aiprt-project-init-be/bigProject/lists',
			data: {
				"page": 1,
				"num": 10,
			}
		}).then(res => {
			const list = (res?.list || []).map(item => {
				return {
					id: item.id,
					projectCode: item.projectCode,
					noticeName: item.noticeName,
					releaseTime: item.releaseTime,
					noticeType: "12",
					listDataType: 'bigProject'

				}
			})
			setNoticeList(list)
		})
	}
	const requestPurchaseIntentionListApi = () => {
		request({
			method: 'post',
			url: '/aiprt-common-notice-be/purchaseIntentionNotice/getListData',
			data: {
				"page": 1,
				"num": 10,
			}
		}).then(res => {
			const list = (res?.list || []).map(item => {
				return {
					id: item.id,
					projectCode: '',
					noticeName: item.name,
					releaseTime: item.releaseTime || item.pubts || item.auditTime || item.createTime,
					noticeType: '',
					listDataType: 'purchaseIntentionNotice'
				}
			})
			setNoticeList(list)
		})
	}

	useEffect(() => {
			switch (select.types) {
			case "2": // 采购公示
			case "5": // 其它公告
				inquiryListApi();
				break;
			case "3": // 询价寻源
				inquiryListApi(noticeClassfiy.pt);
				break;
			case "9": // 合同公示
				requestContractListApi();
				break;
			case "10": // 采购意向公示
				requestPurchaseIntentionListApi();
				break;
			case "19": // 重大项目
				requestBigProjectListApi()
				break
			default:
				noticeListApi();
				break;
		}
	}, [noticeClassfiy, select, searchText]);
	const  getMoreUrl = () => {
		// return `/notice-more/${noticeClassfiy.classfiy}/${select.id}/${select.types}`;
		return `/notice-more/${select.types}/${select.id}/${select.types}`;
	}
	return (
		<>
		<div className="brandBox" >
			<div className="brandBox-width">
				<div className="brandBox-list">
					<h4><img src={brand1} />招采（交易）公告</h4>
					<div>
						{NoticeClassfiyList.filter(item => item.types !== '10').map(
							(item, index) => (
								<NavItem key={item.classfiy} text={item.text} index={index} onMouseEnter={(e) => {
									if(!NoticeClassfiyList[e.target.getAttribute("index")]) return ;
									setNoticeClassfiy(NoticeClassfiyList[e.target.getAttribute("index")]);
									switch (item.types) {
										case '2':
											setSelect(TypesSlect[3])
											break;
										case '3': // 询价寻源
											setSelect(TypesSlect[6])
											break;
										case '5': // 其它公告
											setSelect(TypesSlect[9])
											break;
										case '9': // 合同公示
											setSelect(TypesSlect[10])
											break;
										case '18': // 重大项目
											setSelect(TypesSlect[19])
											break;
										case '10':// 采购意向公示
											setSelect(TypesSlect[18])
											break;
										default:
											setSelect(TypesSlect[0])
											break;
									}
									
								}}/>
							)
						)}
					</div>
				</div>
				<div className="brandBox-list">
					<h4><img src={brand2} />保函与订单融资</h4>
					<div>
						<a>投标保函</a>
						<a>履约保函</a>
						<Link to="/loan">订单融资</Link>
					</div>
				</div>
				<div className="brandBox-list">
					<h4><img src={brand3} />增值服务</h4>
					<div>
						<a>生态融合</a>
						<a>数据与分析</a>
						<a>咨询服务</a>
						<a>合作与商机</a>
					</div>
				</div>
				<div className="brandBox-list">
					<h4><img src={brand4} />投标供应商服务</h4>
					<div>
						<Link to="/register">登记与备案</Link>
						{user?<Link to="/notice-more/1/2/1">报名与投标</Link>:
							<a onClick={() => {
								sessionStorage.setItem('afterLogin', location.href)
								location.href = 'https://aiprt.aipuret.cn/portal-notice/#/login?redirect='
									+
									'https://aiprt.aipuret.cn/aiprt-bid-opening-be/aiprt/login/userredirect'
							}}>报名与投标</a>
						}
						<a>数据与商机</a>
						<a>咨询服务</a>
						<a>数智采学堂</a>
						{/* <Link to="/classroom">数智采学堂</Link> */}
						<a>订阅资讯</a>
					</div>
				</div>
				<div className="brandBox-list">
					<h4><img src={brand5} />工作平台</h4>
					{user?
						<div>
							<a href="https://aiprt.aipuret.cn/#/" target="_blank">采购人</a>
							<a href="https://aiprt.aipuret.cn/#/" target="_blank">代理机构</a>
							<a href="https://aiprt.aipuret.cn/#/" target="_blank">评审专家</a>
							<a href="https://aiprt.aipuret.cn/#/" target="_blank">评审定标</a>
						</div>:
						<div>
							<a onClick={() => {
									sessionStorage.setItem('afterLogin', location.href)
									location.href = 'https://aiprt.aipuret.cn/portal-notice/#/login?redirect='
										+
										'https://aiprt.aipuret.cn/aiprt-bid-opening-be/aiprt/login/userredirect'
								}}>采购人</a>
							<a onClick={() => {
									sessionStorage.setItem('afterLogin', location.href)
									location.href = 'https://aiprt.aipuret.cn/portal-notice/#/login?redirect='
										+
										'https://aiprt.aipuret.cn/aiprt-bid-opening-be/aiprt/login/userredirect'
								}}>代理机构</a>
							<a onClick={() => {
									sessionStorage.setItem('afterLogin', location.href)
									location.href = 'https://aiprt.aipuret.cn/portal-notice/#/login?redirect='
										+
										'https://aiprt.aipuret.cn/aiprt-bid-opening-be/aiprt/login/userredirect'
								}}>评审专家</a>
							<a onClick={() => {
									sessionStorage.setItem('afterLogin', location.href)
									location.href = 'https://aiprt.aipuret.cn/portal-notice/#/login?redirect='
										+
										'https://aiprt.aipuret.cn/aiprt-bid-opening-be/aiprt/login/userredirect'
								}}>评审定标</a>
						</div>
					}
				</div>
			</div>
		</div>
		<div style={{background:"#fff"}}>
			<div className="notice box" style={{paddingBottom:"30px"}}>
				<div className="notice-title">
					<h3>{noticeClassfiy.text || '项目公告'}</h3>
					<Link to={getMoreUrl()} className="notice-more">{'查看更多 >> '}</Link>
				</div>
				<div className="notice-grid">
				<div className="notice-searchbox" onClick={e=>onSelected(e)} id="">
					{TypesSlect.filter(item => noticeClassfiy?item.types == noticeClassfiy.types && item.id != '17' :item.types != '4' && !item.pt).map((item, index) => 
						(
							<Condition selected={select.id == item.id} key={item.id} item={item.text} index={index} dataId={item.id} type={item.type} />
						)
					)}
				</div>
				<div style={{display:'flex', flexWrap:'wrap'}}>
					{
						noticeList.length > 0 ? (noticeList.map(item => {
								return <NoticeItem key={item.id} id={item.id} projectCode={item.projectCode}
									noticeName={item.noticeName}
									time={item.releaseTime}
									noticeType={item.noticeType}
									listDataType={item.listDataType}/>
							}))
							: (<div className="nodata">正在努力发布中...</div>)
					}
				</div>
				</div>
			</div>
		</div>
		<div className="classBox">
			<div className="classBox-mail">
				<div className="bookCheck">
					<div className="bookCheck-title">中标通知书真伪查询</div>
					<BookCheck></BookCheck>
				</div>
				<div className="classBox-main">
					<div className="classBox-title">操作指南</div>
					<div className="classBox-con">
						<div className="classList">
							<a href="https://kdocs.cn/l/cgSZR8UURsH6" target="_blank">
								<div><img src={class1} /></div>
								<p>供应商操作指南</p>
								<div className="classBottom"><span>最近在学1万人</span><span>马上看</span></div>
							</a>
						</div>
						<div className="classList">
							<a href="https://kdocs.cn/l/cnh77j3fhe0Y" target="_blank">
								<div><img src={class2} /></div>
								<p>代理机构操作指南</p>
								<div className="classBottom"><span>最近在学2500人</span><span>马上看</span></div>
							</a>
						</div>
						<div className="classList">
							<a href="https://kdocs.cn/l/cjz532yCF341" target="_blank">
								<div><img src={class3} /></div>
								<p>采购单位操作指南</p>
								<div className="classBottom"><span>最近在学1120人</span><span>马上看</span></div>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		</>
	);
}
